<div class="relative">
  <div class="container w-[260px]  min-w-full">
    <div class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] pb-2">
      <div class="flex flex-row items-center gap-3 w-full">
        <div>
          <tui-svg src="tuiIconUserLarge" style="color: #000000;"></tui-svg>
        </div>
        <div>
          <h3 class="flex items-center text-[#000000] font-bold text-[1.5rem]">Users</h3>
        </div>
      </div>
      <div class="flex gap-2 mt-3 sm:mt-0">
        <div>
          <button tuiButton appearance="" (click)="toggle()">
            <div class="flex justify-center gap-2 items-center btn-outline w-[80px] sm:w-[190px]">
              <tui-svg src="tuiIconSlidersLarge" class="sm:pt-3 rotate-90 flex items-center"
                style="color: #bb0021;"></tui-svg>
              <p class="hidden sm:block">Advanced Search</p>
            </div>
          </button>
        </div>
        <div>
          <button tuiButton appearance="" (click)="navigateToAdd()">
            <div class="flex justify-center items-center w-[180px] sm:w-[160px] btn-outline">
              <p class="flex justify-center items-center text-[13px] h-[24px]">Add New User</p>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="mt-2 sm:mt-0">
      <div class="flex flex-col lg:flex-row justify-between" *ngIf="showSearch">
        <div class="flex sm:items-center gap-1 flex-col sm:flex-row">
          <div class="w-full sm:w-60">
            <tui-input tuiTextfieldIconLeft="tuiIconSearchLarge" [tuiTextfieldCleaner]="true" tuiTextfieldSize="m"
              [tuiTextfieldLabelOutside]="true" [style.text-align]="'left'" [(ngModel)]="searchText"
              (tuiValueChanges)="cancelSearch($event)">
              Search
              <input tuiTextfield type="text" />
            </tui-input>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-40 py-3">
            <tui-select [(ngModel)]="userStatus" (ngModelChange)="statusChange()" tuiTextfieldSize="m"
              [tuiTextfieldLabelOutside]="true" [style.text-align]="'left'">
              Activate Status
              <input autocomplete="status" tuiTextfield type="text" />
              <tui-data-list-wrapper *tuiDataList [items]="statusitems">
              </tui-data-list-wrapper>
            </tui-select>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-[100px] my-3">
            <button tuiButton tuiTextfieldSize="s" type="button" class="w-full" (click)="search()">
              <tui-svg src="tuiIconSearchLarge" class="pr-2 text-white"></tui-svg>
              <span class="text-white">Search</span>
            </button>
          </div>
        </div>
        <!--    <div class="text-[#FFFFFFB8] flex gap-1 items-center justify-end">-->
        <!--      <label>-->
        <!--          Active-->
        <!--          <tui-toggle-->
        <!--              size="l"-->
        <!--             -->
        <!--          ></tui-toggle>-->
        <!--      </label>-->
        <!--    </div>-->
      </div>

      <div class="flex justify-between p-2 pr-5 bg-[#faf0f2] rounded mt-2  w-full" *ngIf="statusMsg">
        <div class="flex items-center">
          <img src="/assets/img/resulticon.png" alt="">
          <p class="text-black pl-2">{{showText()}}</p>
        </div>
        <div>
          <button class="text-[#bb0021] hover:scale-110 transition-all duration-100" (click)="resetStatus()">Reset
          </button>
        </div>
      </div>
    </div>
    <tui-loader [overlay]="true" [showLoader]="isLoading" class="mt-3">
      <div *ngIf="userData.length > 0" class="overflow-x-scroll" style="white-space: nowrap">
        <table class="tui-table w-full">
          <thead tuiThead>
            <tr class="tui-table__tr">
              <th class="tui-table__th">User ID</th>
              <th class="tui-table__th">Full Name</th>
              <th class="tui-table__th">Email Address</th>
              <th class="tui-table__th">Mobile Number</th>
              <th class="tui-table__th">Role</th>
              <th class="tui-table__th">Status</th>
              <th class="tui-table__th">
                <div class="flex">
                  <span>Created Date</span>
                  <tui-svg class=" nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronUp" (click)="toggleSort()" *ngIf="sort === -1"></tui-svg>

                  <tui-svg class=" nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronDown" (click)="toggleSort()" *ngIf="sort === 1"></tui-svg>
                </div>
              </th>
              <th class="tui-table__th" style="width:100px;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tui-table__tr" *ngFor="let data of userData; let i = index">
              <td class="tui-table__td">{{ data.userId ? data.userId : '-' }}
              </td>
              <td class="tui-table__td">{{ data.firstname ? data.firstname : '-' }} {{ data.lastname ? data.lastname :
                '-' }}</td>
              <!-- <td class="tui-table__td">{{ data.email ? data.email : '-' }}</td>
            <td class="tui-table__td">{{ data.mobileNo ? data.mobileNo : '-' }}</td> -->
              <td class="tui-table__td">
                <a *ngIf="data.email" href="mailto:{{ data.email }}">{{ data.email }}</a>
                <span *ngIf="!data.email">-</span>
              </td>
              <td class="tui-table__td">
                <a *ngIf="data.mobileNo" href="tel:{{ data.mobileNo }}">{{ data.mobileNo }}</a>
                <span *ngIf="!data.mobileNo">-</span>
              </td>
              <td class="tui-table__td" *ngIf="data.role === 'ADMIN'">Admin</td>
              <td class="tui-table__td" *ngIf="data.role === 'STAFF'">Staff</td>
              <td class="tui-table__td" *ngIf="data.role === 'SUPPORT'">Support</td>
              <td class="tui-table__td" *ngIf="data.role === 'SUPER_ADMIN'">Super Admin</td>
              <td class="tui-table__td">
                <div class="flex items-center gap-1" *ngIf="data.isActive">
                  <div class="w-[10px] h-[10px] rounded-full bg-[#4AC99B]"></div>
                  Active
                </div>
                <div class="flex items-center gap-1" *ngIf="!data.isActive">
                  <div class="w-[10px] h-[10px] rounded-full bg-[#FF4646]"></div>
                  Inactive
                </div>
              </td>
              <td class="tui-table__td">{{ data.createdAt ? (data.createdAt | date: "yyyy-MM-dd") : '-' }}</td>
              <td class="tui-table__td">
                <div class="flex items-center justify-between" style="width:100px;">
                  <a class="black font-bold hover:scale-110 transition-all duration-100" style="cursor: pointer;"
                    (click)="navigateToUpdate(data)">Edit</a>
                  <button [disabled]="data.role === 'SUPER_ADMIN'" [tuiDropdown]="dropdownContent"
                    [tuiDropdownManual]="openStates[i]" (click)="onClick(i)"
                    (tuiActiveZoneChange)="onActiveZone($event)" (tuiObscured)="onObscured($event)">
                    <tui-svg src="tuiIconMoreVertical" class="hover:scale-110 transition-all duration-100"></tui-svg>
                    <ng-template #dropdownContent>
                      <div class="dropdown dropdownContent" (click)="onSendNewPassword(data._id,data.email)">Resend
                        Credentials
                      </div>
                      <!-- <div class="dropdown dropdownContent" *ngIf="checkValid(data.role)" -->
                      <div class="dropdown dropdownContent" (click)="onStatusChange(data)">Change Status
                      </div>
                      <div class="dropdown dropdownContent" style="color: red" (click)="onDelete(data._id,data.email)">
                        Delete
                      </div>
                    </ng-template>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="userData.length === 0 && !isLoading" class="mt-3">
        <p class="text-[#D8D8D8] text-center">No Data</p>
      </div>
    </tui-loader>
    <div class="text-white py-10 flex justify-end w-full max-w-full">
      <tui-pagination [index]="pageSize.pageIndex-1" [length]="pageSize.length" (indexChange)="goToPage($event)"
        class="text-white">
      </tui-pagination>
    </div>
  </div>
</div>